import { render, staticRenderFns } from "./Kellnerruf.vue?vue&type=template&id=2fdb4ec8&scoped=true"
import script from "./Kellnerruf.vue?vue&type=script&lang=js"
export * from "./Kellnerruf.vue?vue&type=script&lang=js"
import style0 from "./Kellnerruf.vue?vue&type=style&index=0&id=2fdb4ec8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb4ec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdb4ec8')) {
      api.createRecord('2fdb4ec8', component.options)
    } else {
      api.reload('2fdb4ec8', component.options)
    }
    module.hot.accept("./Kellnerruf.vue?vue&type=template&id=2fdb4ec8&scoped=true", function () {
      api.rerender('2fdb4ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Kellnerruf.vue"
export default component.exports